import React from 'react'
import DashLayout from '../../../Components/Admin/AdminDashLayout'
import { Layout } from 'antd'
import InterviewMainSection from './InterviewMainSection'

const Interviews = () => {
    return (
        <Layout title="Courses | Office Flow">
            <DashLayout >
                <InterviewMainSection />
            </DashLayout>
        </Layout>

    )
}

export default Interviews